export default {
  title: '',
  menu: '',
  label: {
    open: 'Open',
    finished: 'Finished',
    all: 'All',
    publishing: 'Publishing',
    taskDate: 'Task Date',
    postStatus: 'Post Status',
    job: 'Job',
    jobAffiliatedCompany: 'Job Affiliated Company',
    jobCloseDate: 'Job Close Date',
    taskFinishDate: 'Task Finish Date',
    postChannel: 'Post Channel',
    action: 'Action'
  },
  placeholder: {
    searchJobTitle: 'Search for a job by title',
    thirdPartyJobLink: 'Third Party Job Link'
  },
  message: {
  }
}
